import { BRAND_DOMAIN } from '@/config/brand';

// Versioned artwork prevents reuse of pre-rebrand social-card caches.
export const SITE_URL = import.meta.env.VITE_ISOLATED_STAGING === 'true'
  ? `https://staging.${BRAND_DOMAIN}`
  : `https://${BRAND_DOMAIN}`;
export const SOCIAL_IMAGE_URL = `${SITE_URL}/og-image.jpg?v=scopie`;
export const BRAND_LOGO_URL = `${SITE_URL}/brand/scopie-icon-512.png`;
